// swiper-init.js
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Swiper.use([Autoplay, Navigation, Pagination]);

export function initCarousels(container = document) {
	const carousels = container.querySelectorAll(
		".image-carousel.swiper-container",
	);

	carousels.forEach((carousel) => {
		if (carousel.classList.contains("swiper-initialized")) return;

		const slides = parseInt(carousel.dataset.slides || 1);
		const isAutoplayEnabled = carousel.dataset.autoplay === "true";
		const speed = parseInt(carousel.dataset.speed || 500);
		const showPagination = carousel.dataset.pagination === "true";

		new Swiper(carousel, {
			loop: true,
			speed,
			slidesPerView: slides,
			modules: [Autoplay, Navigation, Pagination],
			navigation: {
				nextEl: carousel.querySelector(".swiper-button-next"),
				prevEl: carousel.querySelector(".swiper-button-prev"),
			},
			autoplay: isAutoplayEnabled
				? {
						delay: speed,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
				  }
				: false,
			pagination: showPagination
				? {
						el: carousel.querySelector(".swiper-pagination"),
						clickable: true,
				  }
				: false,
		});
	});
}
